import cn from "classnames";
import { defaultMultipleSelectProps, ValueContainer } from "components/shared/select";
import { reportFilterWrapper, SelectColumnFilter } from "helpers/reactTable";
import { columnName, formatValue, typeSpecificProps } from "helpers/reports";
import React from "react";
import CommonReport from "./commonReport";

const filterKeys = {
    CompletionMethod: "completionMethod",
    FederalDistrict: "federalDistrict",
    State: "state",
};

const calculateFilterOptions = (data) => {
    const uniqKeys = Object.values(filterKeys).reduce((acc, key) => ({ ...acc, [key]: {} }), {});

    return Object.values(filterKeys).reduce((acc, key) => {
        acc[key] = data.reduce((options, item) => {
            if (uniqKeys[key][item[key]]) {
                return options;
            }
            uniqKeys[key][item[key]] = true;
            options.push({ label: item[key], value: item[key] });
            return options;
        }, []);
        return acc;
    }, {});
};

export default class CarIdlesReport extends CommonReport {
    constructor(props) {
        super(props);
        this.state.filterOptions = calculateFilterOptions(props.data.data);
        this.state.ignoreLeaveDeviation = false;
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.dataLoadedAt !== this.props.dataLoadedAt) {
            this.setState({ filterOptions: calculateFilterOptions(nextProps.data.data) });
        }
    }

    defaultColumnProps = (column) => {
        const key = filterKeys[column.propertyName];

        if (!key) {
            return typeSpecificProps(column);
        }

        return {
            Filter: reportFilterWrapper((props) => (
                <SelectColumnFilter
                    {...props}
                    selectProps={{
                        ...defaultMultipleSelectProps,
                        options: this.state.filterOptions[key],
                        inputProps: { name: key },
                        components: { ValueContainer },
                    }}
                />
            )),
            filter: (rows, _id, filterValue) => {
                if (!filterValue || !filterValue.value || filterValue.value.length === 0) {
                    return rows;
                }
                return rows.filter((row) => filterValue.value.includes(row.values[key]));
            },
        };
    };

    toggleIgnoreLeaveDeviation = () => {
        this.setState({ ignoreLeaveDeviation: !this.state.ignoreLeaveDeviation }, () =>
            this.setState({ tableDefaultProps: this.tableDefaultProps() }),
        );
    };

    cellProps = (column) => {
        return {
            Header: column.label,
            accessor: columnName(column),
            Cell: (props) => {
                const { bidId } = props.row.values;
                const uniqueId = { [`data-${props.column.id}`.toLowerCase()]: bidId };
                switch (props.column.id) {
                    case "carLogistId": {
                        const { subRows } = props.row;
                        const logistName =
                            subRows[0].subRows[0].subRows[0].original?.carLogistDisplayName || "Без логиста";
                        const rowCount = /\(\d+\)$/.test(logistName) ? "" : ` (${subRows.length})`;
                        return `${logistName}${rowCount}`;
                    }
                    case "carId": {
                        const { subRows } = props.row;
                        const { car } = subRows[0].subRows[0].original;
                        return <span data-car={car}>{car}</span>;
                    }
                    case "bidId": {
                        return <span data-bidid={props.value}>{props.value}</span>;
                    }
                }
                return <span {...uniqueId}>{formatValue(props.value, column.clrType)}</span>;
            },
            ...this.defaultColumnProps(column),
        };
    };

    extractColumns = () => {
        const { columns } = this.props.data || {};
        return columns.map((column) => {
            return {
                ...this.cellProps(column),
                filterable: !["CarLogistId", "CarId"].includes(column.propertyName),
                aggregate: () => null,
                Aggregated: () => null,
            };
        });
    };

    tableExtraProps = () => {
        return {
            withoutFooter: true,
            initialState: {
                groupBy: ["carLogistId", "carId", "bidId"],
                hiddenColumns: ["carLogistDisplayName", "car"],
            },
            getRowProps: (row) => {
                if (row.isGrouped) {
                    return {};
                }
                const { enterDeviation, leaveDeviation } = row.values;
                const hasEnterDeviation = enterDeviation && enterDeviation.charAt(0) !== "-";
                const hasLeaveDeviation =
                    !this.state.ignoreLeaveDeviation && leaveDeviation && leaveDeviation.charAt(0) !== "-";
                if (hasEnterDeviation || hasLeaveDeviation) {
                    return { className: "tr reports__item--red" };
                } else {
                    return { className: "tr reports__item--green" };
                }
            },
        };
    };

    render() {
        const checkboxCname = cn("checkbox d-inline-block mr-2", {
            "checkbox--checked": this.state.ignoreLeaveDeviation,
        });

        return (
            <>
                {!this.props.isPrintForm && (
                    <div>
                        <div className="mb-1 p-0 btn" onClick={this.toggleIgnoreLeaveDeviation}>
                            <span className={checkboxCname} />
                            <small>Не считать отклонения по выездам</small>
                        </div>
                    </div>
                )}
                {super.render()}
            </>
        );
    }
}
